var _defs, _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgMultipleChoice = function SvgMultipleChoice(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".multiple-choice_svg__a{fill:none;stroke:currentColor;stroke-linecap:round;stroke-linejoin:round}"))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 23,
    height: 23,
    x: 0.5,
    y: 0.499,
    className: "multiple-choice_svg__a",
    rx: 2,
    ry: 2
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m5 7.499 1.5 1.5 4-4M5 17.499l1.5 1.5 4-4M13.5 8.499h6M13.5 17.499h6",
    className: "multiple-choice_svg__a"
  })));
};
export default SvgMultipleChoice;